<div class="detail-page">
  <div class="otsake-container">
    <button class="sulje light-blue-text" mat-button (click)="peruuta()" type="button" [attr.aria-label]="'yleiset.peruuta' | translate | async">
      <i style="font-size: 60px; width: 60px; height: 60px; line-height: 60px; display: inline-block" class="icon ion-md-arrow-back"></i>
    </button>
  </div>
  <form (ngSubmit)="save()" novalidate>
    <div style="max-width: 450px">
      <mat-form-field>
        <mat-label>{{ 'tuote.nimi' | translate | async }}</mat-label>
        <input #nimiInput type="text" [formField]="lomake.nimi" matInput data-lpignore="true" />
        <mat-error>{{ fieldErrors().nimi }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'tuote.hinta' | translate | async }}</mat-label>
        <input decimalNumberField matInput [formField]="lomake.hinta" />
        <mat-error>{{ fieldErrors().hinta }}</mat-error>
      </mat-form-field>
      <div style="display: flex; justify-content: space-between">
        <button class="secondarybutton" mat-button routerLink="/laskutus/tuotteet" type="button">{{ 'yleiset.peruuta' | translate | async }}</button>
        @if (tuote?.$key && tuote?.$key !== 'uusi') {
          <button class="secondarybutton" mat-button (click)="poista()" type="button">{{ 'yleiset.poista' | translate | async }}</button>
        }
        <button class="primarybutton" mat-button (click)="save()" type="button">{{ 'yleiset.tallenna' | translate | async }}</button>
      </div>
    </div>
  </form>
</div>
